// @flow

/**
 * Module dependencies.
 */

import { h1, h2, h3, h4, paragraph, small } from 'client/styles';
import { setPropStyle } from 'client/core/utils';
import styled from 'styled-components';

/**
 * Global content types.
 */

const typesToGenerate = {
  H1: h1,
  H2: h2,
  H3: h3,
  H4: h4,
  Paragraph: paragraph,
  Small: small
};

/**
 * Generated types.
 */

export default Object
  .keys(typesToGenerate)
  .reduce((typographyElements: Object, key: string): Object => ({
    ...typographyElements,
    [key]: styled(`${key}`)`
      ${typesToGenerate[key]}

      ${setPropStyle('align', 'text-align')}
      ${setPropStyle('color')}
      ${setPropStyle('marginBottom')}
      ${setPropStyle('weight', 'font-weight')}
      ${setPropStyle('transform', 'text-transform')}
    `
  }), {});



// WEBPACK FOOTER //
// ../src/client/components/core/type.js